<template>
  <div>
    <div class="mb-2">
      {{ $t('vacancy') }}:
      <RouterLink
        :to="{
          name: 'vacancy',
          params: { vacancyId: vacancy.id, companyId: vacancy.companyId }
        }"
      >
        {{ vacancy.title }}
      </RouterLink>
    </div>
    <div class="mb-2">
      {{ $t('company') }}:
      <RouterLink
        v-if="company"
        :to="{
          name: 'company',
          params: { companyId: vacancy.companyId }
        }"
      >
        {{ company.name }}
      </RouterLink>
    </div>
    <hr class="mb-2">
    <VRow>
      <VCol cols="8" xs="12">
        <div class="font-weight-light mb-2 mb-md-0" style="font-size: 1.375rem; line-height: 1.2">
          {{ candidate.firstName }} {{ candidate.lastName }}
        </div>
      </VCol>
      <VCol cols="4" xs="12">
        <CandidateRating
          :candidate="candidate"
          description
          size="16"
        />
        <div v-if="hideBlockRatingComputed" />
        <div v-else class="d-flex justify-end mt-1">
          <div class="ai-text-review">
            <template
              v-if="isAiRatingAvailable"
            >
              <span>{{ candidateRating }}/5</span>
              {{ $t('accordingAi') }}
            </template>

            <template v-else-if="isProcessingAi">
              {{ $t('evAiIsProcessing') }}
            </template>

            <template v-else-if="isAvailableAi">
              {{ $t('availableAi') }}
            </template>

            <template v-else-if="isNotAvailableAi">
              {{ $t('notAvailableAi') }}
            </template>
          </div>

          <VMenu
            offset-y
            open-on-click
            left
            nudge-right="25"
            transition="scale-transition"
            origin="right top"
          >
            <template v-slot:activator="{ on, attrs }">
              <div
                class="icon-more-detailed"
                v-bind="attrs"
                v-on="on"
              >
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_2794_4899)">
                    <path d="M7 0C5.61553 0 4.26216 0.410543 3.11101 1.17971C1.95987 1.94888 1.06266 3.04213 0.532846 4.32122C0.003033 5.6003 -0.13559 7.00777 0.134506 8.36563C0.404603 9.7235 1.07129 10.9708 2.05026 11.9497C3.02922 12.9287 4.2765 13.5954 5.63437 13.8655C6.99224 14.1356 8.3997 13.997 9.67879 13.4672C10.9579 12.9373 12.0511 12.0401 12.8203 10.889C13.5895 9.73785 14 8.38447 14 7C13.998 5.1441 13.2599 3.36479 11.9475 2.05247C10.6352 0.74015 8.8559 0.0020073 7 0ZM7 12.25C5.96165 12.25 4.94662 11.9421 4.08326 11.3652C3.2199 10.7883 2.547 9.9684 2.14964 9.00909C1.75228 8.04978 1.64831 6.99418 1.85088 5.97578C2.05345 4.95738 2.55347 4.02192 3.28769 3.28769C4.02192 2.55346 4.95738 2.05345 5.97578 1.85088C6.99418 1.6483 8.04978 1.75227 9.00909 2.14963C9.9684 2.54699 10.7883 3.2199 11.3652 4.08326C11.9421 4.94661 12.25 5.96165 12.25 7C12.2483 8.39187 11.6946 9.72624 10.7104 10.7104C9.72624 11.6946 8.39187 12.2483 7 12.25Z" fill="#757575" />
                    <path d="M6.73454 5.5679H6.55954C6.33028 5.56227 6.10718 5.64248 5.93399 5.7928C5.76079 5.94312 5.64998 6.15271 5.6233 6.38049C5.60803 6.60835 5.68247 6.83315 5.83069 7.00689C5.97892 7.18062 6.1892 7.28952 6.41663 7.31032V10.0228C6.41663 10.2549 6.50882 10.4774 6.67291 10.6415C6.837 10.8056 7.05956 10.8978 7.29163 10.8978C7.52369 10.8978 7.74625 10.8056 7.91035 10.6415C8.07444 10.4774 8.16663 10.2549 8.16663 10.0228V6.99999C8.16663 6.62018 8.01575 6.25592 7.74718 5.98735C7.47861 5.71878 7.11436 5.5679 6.73454 5.5679Z" fill="#757575" />
                    <path d="M6.9009 4.93852C7.09888 4.93852 7.29241 4.87982 7.45703 4.76982C7.62164 4.65983 7.74994 4.5035 7.82571 4.32059C7.90147 4.13768 7.92129 3.93641 7.88267 3.74224C7.84404 3.54806 7.74871 3.3697 7.60872 3.22971C7.46872 3.08972 7.29036 2.99438 7.09619 2.95576C6.90201 2.91713 6.70074 2.93696 6.51784 3.01272C6.33493 3.08848 6.17859 3.21678 6.0686 3.3814C5.95861 3.54601 5.8999 3.73954 5.8999 3.93752C5.89983 4.069 5.92567 4.1992 5.97594 4.32068C6.02622 4.44216 6.09995 4.55254 6.19292 4.64551C6.28588 4.73848 6.39626 4.81221 6.51775 4.86248C6.63923 4.91276 6.76943 4.9386 6.9009 4.93852Z" fill="#757575" />
                  </g>
                  <defs>
                    <clipPath id="clip0_2794_4899">
                      <rect width="14" height="14" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            </template>
            <template>
              <div class="mb-2">
                {{ $t('textTooltipAi.1') }}
              </div>
              <span>
                {{ $t('textTooltipAi.2') }}
              </span>
            </template>
          </VMenu>
        </div>
      </VCol>
    </VRow>
    <VRow>
      <VCol cols="12" sm="7" class="py-0" style="font-size: 0.875rem">
        <div v-if="candidate.birthDate" class="mb-1">
          {{ $t('birthDate') }}:
          {{ birthDate }}
        </div>
        <div v-if="candidate.location">
          {{ candidate.location }}
        </div>
      </VCol>
      <VCol cols="12" sm="5" class="py-0">
        <div
          v-if="candidate.resume"
          class="d-flex justify-sm-end align-center cursor-pointer mt-2 mt-sm-0"
          @click="downloadResume"
        >
          <VIcon small class="mr-2" style="padding-top: 1px">
            {{ mdiDownload }}
          </VIcon>
          <span
            class="text-decoration-underline"
            :class="{ 'primary--text': candidate.resume }"
            style="font-size: 0.875rem; line-height: 1.1"
          >
            {{ $t('downloadResume') }}
          </span>
        </div>
      </VCol>
    </VRow>
  </div>
</template>

<script>
import { mdiDownload } from '@mdi/js';
import { ref, computed, toRefs } from '@vue/composition-api';
import { vacancyStatus } from '@/enums';
import { format, DATE_FORMATS } from '../../date-utils';
import CandidateRating from './CandidateRating.vue';

export default {
  name: 'CandidateHeader',
  components: {
    CandidateRating,
  },
  props: {
    candidate: {
      type: Object,
      required: true,
    },
    company: {
      type: Object,
      required: true,
    },
    vacancy: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { candidate, vacancy } = toRefs(props);
    const isReadFull = ref(false);
    const isAiRating = computed(() => (candidate.value?.interview?.aiRating === 0 ? true : !!candidate.value?.interview?.aiRating));
    const isAiReview = computed(() => !!candidate.value?.interview?.aiReview);
    const transcriptions = computed(() => candidate.value?.interview?.timestamps?.some(i => i.transcription !== null));
    const candidateInterviewed = computed(() => !!candidate.value?.interview?.video);
    const isAvailableAi = computed(() => !isAiRating.value && !isAiReview.value);

    const isProcessingAi = computed(() => candidateInterviewed.value
    && (!isAiRating.value || !isAiReview.value || !transcriptions.value));

    const ourDate = new Date();
    const published = new Date(vacancy.value.publishedTill);

    const hideBlockRatingComputed = computed(() => (vacancy.value.status === vacancyStatus.ARCHIVE || ourDate > published)
      && !candidate.value?.interview?.aiReview);

    const candidateRating = computed(() => (candidate.value?.interview?.aiRating === 0 ? candidate.value?.interview?.aiRating + 0.5
      : candidate.value?.interview?.aiRating / 2));

    const candidateRatingNull = computed(() => isAiRating.value && isAiReview.value
    && transcriptions.value && candidate.value?.interview?.aiRating === 0);

    const isAiRatingAvailable = computed(() => (isAiRating.value && isAiReview.value && transcriptions.value) || candidateRatingNull.value);

    return {
      isAiRating,
      isAiReview,
      isReadFull,
      isProcessingAi,
      candidateRating,
      candidateRatingNull,
      transcriptions,
      isAvailableAi,
      hideBlockRatingComputed,
      isAiRatingAvailable,
    };
  },
  data() {
    return {
      mdiDownload,
    };
  },
  computed: {
    birthDate() {
      return format(new Date(this.candidate.birthDate), DATE_FORMATS[this.$i18n.locale].short);
    },
  },
  methods: {
    downloadResume() {
      window.open(this.candidate.resume.file.url);
    },
  },
};
</script>

<style lang="scss" scoped>
.ai-text-rating {
  color: #757575;
  text-align: end;
  font-size: 13px;
  font-weight: 400;
  line-height: 21px;
  white-space: nowrap;
  span {
    color: #448AFF;
    font-style: normal;
    font-weight: 600;
  }
}
.ai-text-review {
  color: #757575;
  font-size: 13px;
  text-align: start;
  font-weight: 400;
  line-height: 21px;
  white-space: nowrap;
}

.icon-more-detailed {
  cursor: pointer;
  margin-left: 6px;
  svg {
    &:focus {
      border: none;
      outline: none;
    }
  }
}

.v-menu__content::v-deep {
  background-color: #fff;
  max-width: 370px;
  padding: 15px;
  color: #212121;
  font-size: 14px;
  font-weight: 300;
  line-height: 130%;
}
</style>

<i18n locale="en" lang="yaml">
  downloadResume: Download resume
  vacancy: Job
  company: Company
  firstName: First name
  lastName: Last name
  birthDate: Date of birth
  accordingAi: points based on AI
  city: City
  evAiIsProcessing: Evaluation from AI in processing
  availableAi: AI candidate evaluation is available
  notAvailableAi: Evaluation of the candidate from AI
  textTooltipAi: {
    1: This candidate has been evaluated with the assistance of artificial intelligence (AI).,
    2: 'This evaluation will help you in choosing the best candidate. The candidate’s rating is based on a five-point scale and strict parameters,
    which will allow you to define the pluses and minuses of a candidate in the most maximally accurate way.'
  }
</i18n>

<i18n locale="ru" lang="yaml">
  vacancy: Вакансия
  company: Компания
  firstName: Имя
  lastName: Фамилия
  birthDate: Дата рождения
  city: Город
  downloadResume: Скачать резюме
  accordingAi: по оценке ИИ
  evAiIsProcessing: Оценка от ИИ в обработке!
  availableAi: Доступна оценка кандидата от ИИ
  notAvailableAi: Оценка кандидата от ИИ
  textTooltipAi: {
    1: Данный кандидат был оценен со стороны Искусственного Интеллекта.,
    2: 'Данная оценка поможет Вам в выборе кандидата.
    Оценка проводится по пятибальной шкале и по строгим параметрам, что позволяет максимально точно определить все плюсы и минусы кандидата.'
  }
</i18n>
